import React from 'react'
import PreviewPlayer from './PreviewPlayer'

const PreviewPlayerContainer = props => (<PreviewPlayer {...props} />)

export default PreviewPlayerContainer
